import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { SubscribePlan } from '@zep/types';
const defaultValues = {
  plans: ['free', 'basic', 'pro', 'enterprise'] as SubscribePlan[]
};
export const PricingContext = createContext<PricingContextType | null>(null);
export const PricingProvider = ({
  children
}: PropsWithChildren) => {
  const [visiblePlans, setVisiblePlans] = useState(defaultValues.plans);
  return <PricingContext.Provider value={{
    plans: defaultValues.plans,
    visiblePlans,
    setVisiblePlans
  }} data-sentry-element="unknown" data-sentry-component="PricingProvider" data-sentry-source-file="PricingProvider.tsx">
      {children}
    </PricingContext.Provider>;
};
export const usePricing = () => {
  const context = useContext(PricingContext);
  if (!context) throw new Error('usePricing 은 PricingProvider 안에서만 쓴다');
  return context;
};
type PricingContextType = {
  plans: SubscribePlan[];
  visiblePlans: SubscribePlan[];
  setVisiblePlans: (plans: SubscribePlan[]) => void;
};